import React from "react";
import { Link } from "react-router-dom";

export default function Hero({
  eyebrow,
  title,
  subtitle,
  primaryCta,
  secondaryCta,
  imageSrc,
  imageAlt = "",
  highlights = [],
}) {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-brand-50 via-white to-slate-50" />
      <div className="absolute -top-24 right-[-10%] h-72 w-72 rounded-full bg-brand-200/40 blur-3xl" />
      <div className="absolute -bottom-32 left-[-10%] h-80 w-80 rounded-full bg-slate-200/60 blur-3xl" />

      <div className="relative eb-container eb-section">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          <div>
            {eyebrow ? <div className="eb-pill">{eyebrow}</div> : null}

            <h1 className="mt-4 eb-h1">{title}</h1>
            {subtitle ? <p className="mt-5 text-lg eb-muted max-w-xl">{subtitle}</p> : null}

            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
              {primaryCta ? (
                <Link to={primaryCta.to} className="eb-btn-primary">
                  {primaryCta.label}
                </Link>
              ) : null}
              {secondaryCta ? (
                <Link to={secondaryCta.to} className="eb-btn-ghost">
                  {secondaryCta.label}
                </Link>
              ) : null}
            </div>

            {highlights?.length ? (
              <ul className="mt-10 grid gap-3 sm:grid-cols-2 text-sm">
                {highlights.map((item) => (
                  <li key={item} className="flex items-start gap-2 text-slate-700">
                    <span className="mt-1 inline-block h-2 w-2 rounded-full bg-brand-700" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            ) : null}
          </div>

          <div className="relative">
            <div className="eb-card overflow-hidden">
              {imageSrc ? (
                <img
                  src={imageSrc}
                  alt={imageAlt}
                  className="h-[360px] w-full object-cover sm:h-[420px]"
                  loading="eager"
                  decoding="async"
                />
              ) : (
                <div className="h-[360px] w-full bg-gradient-to-br from-brand-100 to-slate-100 sm:h-[420px]" />
              )}
            </div>
            <div className="pointer-events-none absolute -bottom-6 -left-6 hidden h-24 w-24 rounded-3xl bg-brand-700/20 blur-2xl lg:block" />
          </div>
        </div>
      </div>
    </section>
  );
}

